module.exports = __webpack_public_path__ + "img/logo.3ba2cece.png";